import React from 'react'

import { SearchResultProps } from './inteface'

const withSearchResult = (Component: React.FC<SearchResultProps>) => {
  function WithSearchResult(props: SearchResultProps) {
    return <Component {...props} />
  }

  return WithSearchResult
}

export default withSearchResult
